
export interface WsPlayer {
  id: number;
  firstName: string;
  lastName: string;
  title: string;
  handicapIndex: number;
  profilePic: string;
  category: string;
  gender: string;
  homeClub: string;
}

export interface WsTeam {
  id: string;
  name: string;
  owner: string;
  coreMembers: WsPlayer[];
  drafted: WsPlayer[];
  shortlisted: WsPlayer[];
}

export enum WsMessageType {
  Ping = "ping",
  Pong = "pong",
  Close = "close",
  Auth = "auth",
  AuthSuccess = "authSuccess",
  AuthFailed = "authError",
  SetIdentity = "setIdentity", // used to set client as team owner, player, viewer or captain. or as Admin if in admin app


  // calls to server
  CreatTimer = "createTimer", // when server sends a timer start message
  TimerTick = "timerTick", // when server sends a timer tick message
  DraftPickByTeam = "draftPickByTeam",


  // calls from server
  OrderedTeamIds = "orderedTeamIds", // when server sends ordered team ids
  Team = "team", // when server sends team data
  AvailablePlayers = "availablePlayers", // when server sends available players, sends a list of players to choose from.
  IsDraftingOpen = "isDraftingOpen", // when server sends if drafting is open, can send true or false as value.
  ReadyForDrafting = "readyForDrafting", // client sends a message to server that it is ready for drafting - true or false.
  CanTeamOwnerPick = "canTeamOwnerPick", // when server sends if team owner can pick a player, can send true or false as value.
  AddPlayerToDrafted = "addPlayerToDrafted", // sent by client to server that a player is drafted by this team. The player id is sent. Player will be removed from available players list and list re-shared.
  AddPlayerToShortlisted = "addPlayerToShortlisted", // sent by client to server that a player is short listed by a team owner/captain.
  Error = "error",
  ConnectionLimitExceeded = "connectionLimitExceeded",
  FetchMyTeamDetails = "fetchMyTeamDetails", // server sends this when client needs to fetch its team details
  SeasonDraftObject = "seasonDraftObject",


}
